import React, { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

import { useFitnessManagerContext } from '../../FitnessManager/FitnessManagerContext';
import { LazyLoader } from '../../LazyLoader/LazyLoader';
import SettingsModal from '../../SettingsModal/SettingsModal';
import {
  ActivityTypes,
  DisplayPreferences,
  UnitsOfMeasure,
} from '../FitnessSettingsForm/FitnessSettingsForm';

const FitnessSettingsForm = React.lazy(() =>
  import('../FitnessSettingsForm/FitnessSettingsForm'),
);

interface FitnessSettingsEntryProps {
  children: ReactNode;
}

export const FitnessSettingsModal = ({
  children,
}: FitnessSettingsEntryProps) => {
  const { t } = useTranslation('common', { useSuspense: false });
  const { page, modalManager } = useFitnessManagerContext();

  return (
    <SettingsModal
      title={page.title}
      onCloseRequest={modalManager.actions.onCloseModal}
      aria-label={t('settings.fitness.label')}
    >
      <LazyLoader>
        <FitnessSettingsForm>{children}</FitnessSettingsForm>
      </LazyLoader>
    </SettingsModal>
  );
};

FitnessSettingsModal.ActivityTypes = ActivityTypes;
FitnessSettingsModal.UnitsOfMeasurement = UnitsOfMeasure;
FitnessSettingsModal.DisplayPreferences = DisplayPreferences;
